import { createStore, applyMiddleware, compose } from "redux";

import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import { createPromise } from "redux-promise-middleware";
import reducer from "./reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleWare = [];

middleWare.push(thunk);
middleWare.push(createPromise());

const loggerMiddleware = createLogger({
  predicate: () => process.env.NODE_ENV === "development"
});
middleWare.push(loggerMiddleware);

const enhancer = composeEnhancers(applyMiddleware(...middleWare));

export default createStore(reducer, enhancer);
